import { Capacitor } from '@capacitor/core'

/**
 * True when running inside the iOS (or Android) native app shell.
 * Use this to gate any native-only behavior — all code paths must
 * remain functional on the web.
 */
export const isNative = Capacitor.isNativePlatform()

/**
 * True specifically on iOS native (not Android, not web).
 */
export const isIOS = Capacitor.getPlatform() === 'ios'

/**
 * True when running in a standard browser (not Capacitor shell).
 */
export const isWeb = !isNative
